export enum StoreType {
  NEW = 'NEW_STORE',
  EXISTING = 'EXISTING_STORE',
}

export enum SellingType {
  PhysicalProducts = 'PHYSICAL_PRODUCTS',
  DigitalProducts = 'DIGITAL_PRODUCTS',
  PrintOnDemand = 'PRINT_ON_DEMAND',
  Dropshipping = 'DROPSHIPPING',
  Subscriptions = 'SUBSCRIPTIONS',
  Other = 'OTHER',
}

export enum Category {
  FashionApparel = 'FASHION_APPAREL',
  BeautyPersonalCare = 'BEAUTY_PERSONAL_CARE',
  HomeLiving = 'HOME_LIVING',
  ElectronicsGadgets = 'ELECTRONICS_GADGETS',
  SportOutdoors = 'SPORT_OUTDOORS',
  FoodBeverages = 'FOOD_BEVERAGES',
  BooksMediaArt = 'BOOKS_MEDIA_ART',
  Other = 'OTHER',
}

export enum CatalogSize {
  SingleProduct = 'SINGLE_PRODUCT',
  FewProducts = 'FEW_PRODUCTS',
  SmallCollection = 'SMALL_COLLECTION',
  GrowingCatalog = 'GROWING_CATALOG',
}

export enum EcommercePlatform {
  Amazon = 'AMAZON',
  BigCommerce = 'BIGCOMMERCE',
  Etsy = 'ETSY',
  Shopify = 'SHOPIFY',
  Square = 'SQUARE',
  Woo = 'WOO',
  Wordpress = 'WORDPRESS',
  Other = 'OTHER',
}
